unit View.Rt_Credito_Presumido.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UWeb.Enum;

type
  TFViewRt_Credito_PresumidoEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbccredpres: TLabel;
    edccredpres: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbapropria_via_nfe: TLabel;
    lbapropria_via_evento: TLabel;
    lbind_deduz_credpres: TLabel;
    lbind_gcbs_credpres: TLabel;
    lbind_gibs_credpres: TLabel;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientRt_Credito_PresumidoGet: TXDataWebClient;
    Rt_Credito_PresumidoDataset: TXDataWebDataSet;
    Rt_Credito_PresumidoDatasetid: TIntegerField;
    Rt_Credito_PresumidoDatasetccredpres: TIntegerField;
    Rt_Credito_PresumidoDatasetdescricao: TStringField;
    Rt_Credito_PresumidoDatasetapropria_via_nfe: TBooleanField;
    Rt_Credito_PresumidoDatasetapropria_via_evento: TBooleanField;
    Rt_Credito_PresumidoDatasetind_deduz_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetind_gcbs_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetind_gibs_credpres: TBooleanField;
    Rt_Credito_PresumidoDatasetexcluido: TBooleanField;
    Rt_Credito_PresumidoDatasetinclusao: TDateTimeField;
    Rt_Credito_PresumidoDatasetalteracao: TDateTimeField;
    Rt_Credito_PresumidoDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    cbApropria_via_nfe: TDBCheckBox;
    cbApropria_via_evento: TDBCheckBox;
    cbInd_deduz_credpres: TDBCheckBox;
    cbInd_gcbs_credpres: TDBCheckBox;
    cbInd_gibs_credpres: TDBCheckBox;
    btSave: TButton;
    lbindNFCe: TLabel;
    cbindNFCe: TDBCheckBox;
    cbindNFSe: TDBCheckBox;
    lbindNFSe: TLabel;
    lbindDecPag: TLabel;
    cbindDecPag: TDBCheckBox;
    cbindNFe: TDBCheckBox;
    lbindNFe: TLabel;
    Rt_Credito_PresumidoDatasetindDecPag: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFe: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFCe: TBooleanField;
    Rt_Credito_PresumidoDatasetindNFSe: TBooleanField;
    procedure btCancelClick(Sender: TObject);
    procedure XDataClientRt_Credito_PresumidoGetLoad(Response: TXDataClientResponse);
    procedure XDataClientRt_Credito_PresumidoDeleteLoad(Response: TXDataClientResponse);
    procedure Rt_Credito_PresumidoDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure edccredpresKeyPress(Sender: TObject; var Key: Char);
    procedure edccredpresClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure Rt_Credito_PresumidoDatasetAfterOpen(DataSet: TDataSet);
    [async]
    procedure btSaveClick(Sender: TObject); async;
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Credito_PresumidoEdit: TFViewRt_Credito_PresumidoEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Credito_PresumidoEdit }

procedure TFViewRt_Credito_PresumidoEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(edccredpres) then
  begin
    TUtils.SetErroClass('lbccredpres', 'Preencha o Ccredpres!');
    Exit;
  end;

  if THelperServer.VerificarCampoVazio(eddescricao) then
  begin
    TUtils.SetErroClass('lbdescricao', 'Preencha a descrição!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Rt_Credito_PresumidoDataset.State in dsEditModes then
    begin
      Rt_Credito_PresumidoDataset.Post;
      Rt_Credito_PresumidoDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewRt_Credito_PresumidoEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewRt_Credito_PresumidoEdit.edccredpresClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbccredpres');
end;

procedure TFViewRt_Credito_PresumidoEdit.edccredpresKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewRt_Credito_PresumidoEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbdescricao');
end;

procedure TFViewRt_Credito_PresumidoEdit.InsertEntity;
begin
  Rt_Credito_PresumidoDataset.Close;
  Rt_Credito_PresumidoDataset.SetJsonData('{}');
  Rt_Credito_PresumidoDataset.Open;
  Rt_Credito_PresumidoDataset.Insert;
end;

class function TFViewRt_Credito_PresumidoEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Credito_PresumidoEdit(AForm).FInserting := AInserting;
    TFViewRt_Credito_PresumidoEdit(AForm).FId := AId;
    TFViewRt_Credito_PresumidoEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewRt_Credito_PresumidoEdit(AForm).InsertEntity
    else
      TFViewRt_Credito_PresumidoEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewRt_Credito_PresumidoEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Credito_PresumidoEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Rt_Credito_PresumidoDataset.Connection.Model.DefaultSchema.FindEntityType(
      Rt_Credito_PresumidoDataset.EntitySetName
    )
  );
  XDataClientRt_Credito_PresumidoGet.Get(Rt_Credito_PresumidoDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewRt_Credito_PresumidoEdit.XDataClientRt_Credito_PresumidoGetLoad(Response: TXDataClientResponse);
begin
  Rt_Credito_PresumidoDataset.Close;
  Rt_Credito_PresumidoDataset.SetJsonData(Response.Result);
  Rt_Credito_PresumidoDataset.Open;
  
  Rt_Credito_PresumidoDataset.Edit;  
end;

procedure TFViewRt_Credito_PresumidoEdit.XDataClientRt_Credito_PresumidoDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewRt_Credito_PresumidoEdit.Rt_Credito_PresumidoDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Rt_Credito_PresumidoDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewRt_Credito_PresumidoEdit.Rt_Credito_PresumidoDatasetAfterOpen(
  DataSet: TDataSet);
begin
  if not TUtils.PossuiPermissao(Rt_Credito_PresumidoDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    btSave.Enabled := False;

    asm
      window.setTimeout(function() {
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormCreditoPresumido');
      }, 200);
    end;
  end;
end;

procedure TFViewRt_Credito_PresumidoEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle');
end;

procedure TFViewRt_Credito_PresumidoEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewRt_Credito_PresumidoEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.rt_credito_presumido.form.lbid');
  lbccredpres := TLabel.Create('view.rt_credito_presumido.form.lbccredpres');
  lbdescricao := TLabel.Create('view.rt_credito_presumido.form.lbdescricao');
  lbapropria_via_nfe := TLabel.Create('view.rt_credito_presumido.form.lbapropria_via_nfe');
  lbapropria_via_evento := TLabel.Create('view.rt_credito_presumido.form.lbapropria_via_evento');
  lbind_deduz_credpres := TLabel.Create('view.rt_credito_presumido.form.lbind_deduz_credpres');
  lbind_gcbs_credpres := TLabel.Create('view.rt_credito_presumido.form.lbind_gcbs_credpres');
  lbind_gibs_credpres := TLabel.Create('view.rt_credito_presumido.form.lbind_gibs_credpres');
  lbexcluido := TLabel.Create('view.rt_credito_presumido.form.lbexcluido');
  lbinclusao := TLabel.Create('view.rt_credito_presumido.form.lbinclusao');
  lbalteracao := TLabel.Create('view.rt_credito_presumido.form.lbalteracao');
  lbexclusao := TLabel.Create('view.rt_credito_presumido.form.lbexclusao');
  lbindNFCe := TLabel.Create('view.rt_credito_presumido.form.lbindNFCe');
  lbindNFSe := TLabel.Create('view.rt_credito_presumido.form.lbindNFSe');
  lbindDecPag := TLabel.Create('view.rt_credito_presumido.form.lbindDecPag');
  lbindNFe := TLabel.Create('view.rt_credito_presumido.form.lbindNFe');
  btCancel := TButton.Create('view.rt_credito_presumido.form.btBack');
  edid := TDBEdit.Create('view.rt_credito_presumido.form.edid');
  edccredpres := TDBEdit.Create('view.rt_credito_presumido.form.edccredpres');
  eddescricao := TDBEdit.Create('view.rt_credito_presumido.form.eddescricao');
  edinclusao := TDBEdit.Create('view.rt_credito_presumido.form.edinclusao');
  edalteracao := TDBEdit.Create('view.rt_credito_presumido.form.edalteracao');
  edexclusao := TDBEdit.Create('view.rt_credito_presumido.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.rt_credito_presumido.form.cbexcluido');
  cbApropria_via_nfe := TDBCheckBox.Create('view.rt_credito_presumido.form.cbapropria_via_nfe');
  cbApropria_via_evento := TDBCheckBox.Create('view.rt_credito_presumido.form.cbapropria_via_evento');
  cbInd_deduz_credpres := TDBCheckBox.Create('view.rt_credito_presumido.form.cbind_deduz_credpres');
  cbInd_gcbs_credpres := TDBCheckBox.Create('view.rt_credito_presumido.form.cbind_gcbs_credpres');
  cbInd_gibs_credpres := TDBCheckBox.Create('view.rt_credito_presumido.form.cbind_gibs_credpres');
  btSave := TButton.Create('view.rt_credito_presumido.form.btSave');
  cbindNFCe := TDBCheckBox.Create('view.rt_credito_presumido.form.cbindNFCe');
  cbindNFSe := TDBCheckBox.Create('view.rt_credito_presumido.form.cbindNFSe');
  cbindDecPag := TDBCheckBox.Create('view.rt_credito_presumido.form.cbindDecPag');
  cbindNFe := TDBCheckBox.Create('view.rt_credito_presumido.form.cbindNFe');
  DataSource := TDataSource.Create(Self);
  Rt_Credito_PresumidoDataset := TXDataWebDataSet.Create(Self);
  Rt_Credito_PresumidoDatasetid := TIntegerField.Create(Self);
  Rt_Credito_PresumidoDatasetccredpres := TIntegerField.Create(Self);
  Rt_Credito_PresumidoDatasetdescricao := TStringField.Create(Self);
  Rt_Credito_PresumidoDatasetapropria_via_nfe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetapropria_via_evento := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_deduz_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_gcbs_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetind_gibs_credpres := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetexcluido := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Credito_PresumidoDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Credito_PresumidoDatasetexclusao := TDateTimeField.Create(Self);
  Rt_Credito_PresumidoDatasetindDecPag := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFCe := TBooleanField.Create(Self);
  Rt_Credito_PresumidoDatasetindNFSe := TBooleanField.Create(Self);
  XDataClientRt_Credito_PresumidoGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbccredpres.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbapropria_via_nfe.BeforeLoadDFMValues;
  lbapropria_via_evento.BeforeLoadDFMValues;
  lbind_deduz_credpres.BeforeLoadDFMValues;
  lbind_gcbs_credpres.BeforeLoadDFMValues;
  lbind_gibs_credpres.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbindNFCe.BeforeLoadDFMValues;
  lbindNFSe.BeforeLoadDFMValues;
  lbindDecPag.BeforeLoadDFMValues;
  lbindNFe.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edccredpres.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  cbApropria_via_nfe.BeforeLoadDFMValues;
  cbApropria_via_evento.BeforeLoadDFMValues;
  cbInd_deduz_credpres.BeforeLoadDFMValues;
  cbInd_gcbs_credpres.BeforeLoadDFMValues;
  cbInd_gibs_credpres.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  cbindNFCe.BeforeLoadDFMValues;
  cbindNFSe.BeforeLoadDFMValues;
  cbindDecPag.BeforeLoadDFMValues;
  cbindNFe.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDataset.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetid.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetccredpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetdescricao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetapropria_via_nfe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetapropria_via_evento.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_deduz_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_gcbs_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetind_gibs_credpres.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetexcluido.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetinclusao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetalteracao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetexclusao.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindDecPag.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFCe.BeforeLoadDFMValues;
  Rt_Credito_PresumidoDatasetindNFSe.BeforeLoadDFMValues;
  XDataClientRt_Credito_PresumidoGet.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Credito_PresumidoEdit';
    Width := 550;
    Height := 360;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 8;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbccredpres.SetParentComponent(Self);
    lbccredpres.Name := 'lbccredpres';
    lbccredpres.Left := 8;
    lbccredpres.Top := 35;
    lbccredpres.Width := 53;
    lbccredpres.Height := 13;
    lbccredpres.Caption := 'Ccredpres:';
    lbccredpres.HeightPercent := 100.000000000000000000;
    lbccredpres.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 8;
    lbdescricao.Top := 62;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbapropria_via_nfe.SetParentComponent(Self);
    lbapropria_via_nfe.Name := 'lbapropria_via_nfe';
    lbapropria_via_nfe.Left := 8;
    lbapropria_via_nfe.Top := 89;
    lbapropria_via_nfe.Width := 88;
    lbapropria_via_nfe.Height := 13;
    lbapropria_via_nfe.Caption := 'Apropria_via_nfe?';
    lbapropria_via_nfe.HeightPercent := 100.000000000000000000;
    lbapropria_via_nfe.WidthPercent := 100.000000000000000000;
    lbapropria_via_evento.SetParentComponent(Self);
    lbapropria_via_evento.Name := 'lbapropria_via_evento';
    lbapropria_via_evento.Left := 8;
    lbapropria_via_evento.Top := 116;
    lbapropria_via_evento.Width := 106;
    lbapropria_via_evento.Height := 13;
    lbapropria_via_evento.Caption := 'Apropria_via_evento?';
    lbapropria_via_evento.HeightPercent := 100.000000000000000000;
    lbapropria_via_evento.WidthPercent := 100.000000000000000000;
    lbind_deduz_credpres.SetParentComponent(Self);
    lbind_deduz_credpres.Name := 'lbind_deduz_credpres';
    lbind_deduz_credpres.Left := 8;
    lbind_deduz_credpres.Top := 143;
    lbind_deduz_credpres.Width := 104;
    lbind_deduz_credpres.Height := 13;
    lbind_deduz_credpres.Caption := 'Ind_deduz_credpres?';
    lbind_deduz_credpres.HeightPercent := 100.000000000000000000;
    lbind_deduz_credpres.WidthPercent := 100.000000000000000000;
    lbind_gcbs_credpres.SetParentComponent(Self);
    lbind_gcbs_credpres.Name := 'lbind_gcbs_credpres';
    lbind_gcbs_credpres.Left := 280;
    lbind_gcbs_credpres.Top := 8;
    lbind_gcbs_credpres.Width := 97;
    lbind_gcbs_credpres.Height := 13;
    lbind_gcbs_credpres.Caption := 'Ind_gcbs_credpres?';
    lbind_gcbs_credpres.HeightPercent := 100.000000000000000000;
    lbind_gcbs_credpres.WidthPercent := 100.000000000000000000;
    lbind_gibs_credpres.SetParentComponent(Self);
    lbind_gibs_credpres.Name := 'lbind_gibs_credpres';
    lbind_gibs_credpres.Left := 280;
    lbind_gibs_credpres.Top := 35;
    lbind_gibs_credpres.Width := 94;
    lbind_gibs_credpres.Height := 13;
    lbind_gibs_credpres.Caption := 'Ind_gibs_credpres?';
    lbind_gibs_credpres.HeightPercent := 100.000000000000000000;
    lbind_gibs_credpres.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 280;
    lbexcluido.Top := 62;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 280;
    lbinclusao.Top := 89;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 280;
    lbalteracao.Top := 116;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 280;
    lbexclusao.Top := 143;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbindNFCe.SetParentComponent(Self);
    lbindNFCe.Name := 'lbindNFCe';
    lbindNFCe.Left := 272;
    lbindNFCe.Top := 172;
    lbindNFCe.Width := 47;
    lbindNFCe.Height := 13;
    lbindNFCe.Caption := 'IndNFCe?';
    lbindNFCe.HeightPercent := 100.000000000000000000;
    lbindNFCe.WidthPercent := 100.000000000000000000;
    lbindNFSe.SetParentComponent(Self);
    lbindNFSe.Name := 'lbindNFSe';
    lbindNFSe.Left := 272;
    lbindNFSe.Top := 199;
    lbindNFSe.Width := 46;
    lbindNFSe.Height := 13;
    lbindNFSe.Caption := 'IndNFSe?';
    lbindNFSe.HeightPercent := 100.000000000000000000;
    lbindNFSe.WidthPercent := 100.000000000000000000;
    lbindDecPag.SetParentComponent(Self);
    lbindDecPag.Name := 'lbindDecPag';
    lbindDecPag.Left := 9;
    lbindDecPag.Top := 172;
    lbindDecPag.Width := 57;
    lbindDecPag.Height := 13;
    lbindDecPag.Caption := 'IndDecPag?';
    lbindDecPag.HeightPercent := 100.000000000000000000;
    lbindDecPag.WidthPercent := 100.000000000000000000;
    lbindNFe.SetParentComponent(Self);
    lbindNFe.Name := 'lbindNFe';
    lbindNFe.Left := 9;
    lbindNFe.Top := 199;
    lbindNFe.Width := 40;
    lbindNFe.Height := 13;
    lbindNFe.Caption := 'IndNFe?';
    lbindNFe.HeightPercent := 100.000000000000000000;
    lbindNFe.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 169;
    btCancel.Top := 288;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Voltar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 125;
    edid.Top := 5;
    edid.Width := 140;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edccredpres.SetParentComponent(Self);
    edccredpres.Name := 'edccredpres';
    edccredpres.Left := 125;
    edccredpres.Top := 32;
    edccredpres.Width := 140;
    edccredpres.Height := 21;
    edccredpres.HeightPercent := 100.000000000000000000;
    edccredpres.MaxLength := 8;
    edccredpres.TabOrder := 7;
    edccredpres.Text := 'edccredpres';
    edccredpres.WidthPercent := 100.000000000000000000;
    SetEvent(edccredpres, Self, 'OnClick', 'edccredpresClick');
    SetEvent(edccredpres, Self, 'OnKeyPress', 'edccredpresKeyPress');
    edccredpres.DataField := 'ccredpres';
    edccredpres.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 125;
    eddescricao.Top := 59;
    eddescricao.Width := 140;
    eddescricao.Height := 21;
    eddescricao.CharCase := wecUpperCase;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 389;
    edinclusao.Top := 86;
    edinclusao.Width := 140;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 15;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 389;
    edalteracao.Top := 113;
    edalteracao.Width := 140;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 16;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 389;
    edexclusao.Top := 140;
    edexclusao.Width := 140;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 17;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 389;
    cbExcluido.Top := 59;
    cbExcluido.Width := 140;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    cbApropria_via_nfe.SetParentComponent(Self);
    cbApropria_via_nfe.Name := 'cbApropria_via_nfe';
    cbApropria_via_nfe.Left := 125;
    cbApropria_via_nfe.Top := 86;
    cbApropria_via_nfe.Width := 140;
    cbApropria_via_nfe.Height := 22;
    cbApropria_via_nfe.Caption := 'cbApropria_via_nfe';
    cbApropria_via_nfe.ChildOrder := 13;
    cbApropria_via_nfe.HeightPercent := 100.000000000000000000;
    cbApropria_via_nfe.WidthPercent := 100.000000000000000000;
    cbApropria_via_nfe.DataField := 'apropria_via_nfe';
    cbApropria_via_nfe.DataSource := DataSource;
    cbApropria_via_evento.SetParentComponent(Self);
    cbApropria_via_evento.Name := 'cbApropria_via_evento';
    cbApropria_via_evento.Left := 125;
    cbApropria_via_evento.Top := 113;
    cbApropria_via_evento.Width := 140;
    cbApropria_via_evento.Height := 22;
    cbApropria_via_evento.Caption := 'cbApropria_via_evento';
    cbApropria_via_evento.ChildOrder := 13;
    cbApropria_via_evento.HeightPercent := 100.000000000000000000;
    cbApropria_via_evento.WidthPercent := 100.000000000000000000;
    cbApropria_via_evento.DataField := 'apropria_via_evento';
    cbApropria_via_evento.DataSource := DataSource;
    cbInd_deduz_credpres.SetParentComponent(Self);
    cbInd_deduz_credpres.Name := 'cbInd_deduz_credpres';
    cbInd_deduz_credpres.Left := 125;
    cbInd_deduz_credpres.Top := 140;
    cbInd_deduz_credpres.Width := 140;
    cbInd_deduz_credpres.Height := 22;
    cbInd_deduz_credpres.Caption := 'cbInd_deduz_credpres';
    cbInd_deduz_credpres.ChildOrder := 13;
    cbInd_deduz_credpres.HeightPercent := 100.000000000000000000;
    cbInd_deduz_credpres.WidthPercent := 100.000000000000000000;
    cbInd_deduz_credpres.DataField := 'ind_deduz_credpres';
    cbInd_deduz_credpres.DataSource := DataSource;
    cbInd_gcbs_credpres.SetParentComponent(Self);
    cbInd_gcbs_credpres.Name := 'cbInd_gcbs_credpres';
    cbInd_gcbs_credpres.Left := 389;
    cbInd_gcbs_credpres.Top := 5;
    cbInd_gcbs_credpres.Width := 140;
    cbInd_gcbs_credpres.Height := 22;
    cbInd_gcbs_credpres.Caption := 'cbInd_gcbs_credpres';
    cbInd_gcbs_credpres.ChildOrder := 13;
    cbInd_gcbs_credpres.HeightPercent := 100.000000000000000000;
    cbInd_gcbs_credpres.WidthPercent := 100.000000000000000000;
    cbInd_gcbs_credpres.DataField := 'ind_gcbs_credpres';
    cbInd_gcbs_credpres.DataSource := DataSource;
    cbInd_gibs_credpres.SetParentComponent(Self);
    cbInd_gibs_credpres.Name := 'cbInd_gibs_credpres';
    cbInd_gibs_credpres.Left := 389;
    cbInd_gibs_credpres.Top := 32;
    cbInd_gibs_credpres.Width := 140;
    cbInd_gibs_credpres.Height := 22;
    cbInd_gibs_credpres.Caption := 'cbInd_gibs_credpres';
    cbInd_gibs_credpres.ChildOrder := 13;
    cbInd_gibs_credpres.HeightPercent := 100.000000000000000000;
    cbInd_gibs_credpres.WidthPercent := 100.000000000000000000;
    cbInd_gibs_credpres.DataField := 'ind_gibs_credpres';
    cbInd_gibs_credpres.DataSource := DataSource;
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 8;
    btSave.Top := 288;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.ChildOrder := 26;
    btSave.HeightPercent := 100.000000000000000000;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    cbindNFCe.SetParentComponent(Self);
    cbindNFCe.Name := 'cbindNFCe';
    cbindNFCe.Left := 389;
    cbindNFCe.Top := 169;
    cbindNFCe.Width := 140;
    cbindNFCe.Height := 22;
    cbindNFCe.Caption := 'cbindNFCe';
    cbindNFCe.ChildOrder := 13;
    cbindNFCe.HeightPercent := 100.000000000000000000;
    cbindNFCe.WidthPercent := 100.000000000000000000;
    cbindNFCe.DataField := 'indNFCe';
    cbindNFCe.DataSource := DataSource;
    cbindNFSe.SetParentComponent(Self);
    cbindNFSe.Name := 'cbindNFSe';
    cbindNFSe.Left := 389;
    cbindNFSe.Top := 196;
    cbindNFSe.Width := 140;
    cbindNFSe.Height := 22;
    cbindNFSe.Caption := 'cbindNFSe';
    cbindNFSe.ChildOrder := 13;
    cbindNFSe.HeightPercent := 100.000000000000000000;
    cbindNFSe.WidthPercent := 100.000000000000000000;
    cbindNFSe.DataField := 'indNFSe';
    cbindNFSe.DataSource := DataSource;
    cbindDecPag.SetParentComponent(Self);
    cbindDecPag.Name := 'cbindDecPag';
    cbindDecPag.Left := 126;
    cbindDecPag.Top := 169;
    cbindDecPag.Width := 140;
    cbindDecPag.Height := 22;
    cbindDecPag.Caption := 'cbindDecPag';
    cbindDecPag.ChildOrder := 13;
    cbindDecPag.HeightPercent := 100.000000000000000000;
    cbindDecPag.WidthPercent := 100.000000000000000000;
    cbindDecPag.DataField := 'indDecPag';
    cbindDecPag.DataSource := DataSource;
    cbindNFe.SetParentComponent(Self);
    cbindNFe.Name := 'cbindNFe';
    cbindNFe.Left := 126;
    cbindNFe.Top := 196;
    cbindNFe.Width := 140;
    cbindNFe.Height := 22;
    cbindNFe.Caption := 'cbindNFe';
    cbindNFe.ChildOrder := 13;
    cbindNFe.HeightPercent := 100.000000000000000000;
    cbindNFe.WidthPercent := 100.000000000000000000;
    cbindNFe.DataField := 'indNFe';
    cbindNFe.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Rt_Credito_PresumidoDataset;
    DataSource.Left := 464;
    DataSource.Top := 280;
    Rt_Credito_PresumidoDataset.SetParentComponent(Self);
    Rt_Credito_PresumidoDataset.Name := 'Rt_Credito_PresumidoDataset';
    Rt_Credito_PresumidoDataset.AfterApplyUpdates := Rt_Credito_PresumidoDatasetAfterApplyUpdates;
    Rt_Credito_PresumidoDataset.AfterOpen := Rt_Credito_PresumidoDatasetAfterOpen;
    Rt_Credito_PresumidoDataset.EntitySetName := 'Rt_Credito_Presumido';
    Rt_Credito_PresumidoDataset.Connection := DMConnection.ApiConnection;
    Rt_Credito_PresumidoDataset.Left := 408;
    Rt_Credito_PresumidoDataset.Top := 256;
    Rt_Credito_PresumidoDatasetid.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetid.Name := 'Rt_Credito_PresumidoDatasetid';
    Rt_Credito_PresumidoDatasetid.FieldName := 'id';
    Rt_Credito_PresumidoDatasetccredpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetccredpres.Name := 'Rt_Credito_PresumidoDatasetccredpres';
    Rt_Credito_PresumidoDatasetccredpres.FieldName := 'ccredpres';
    Rt_Credito_PresumidoDatasetccredpres.Required := True;
    Rt_Credito_PresumidoDatasetdescricao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetdescricao.Name := 'Rt_Credito_PresumidoDatasetdescricao';
    Rt_Credito_PresumidoDatasetdescricao.FieldName := 'descricao';
    Rt_Credito_PresumidoDatasetdescricao.Required := True;
    Rt_Credito_PresumidoDatasetdescricao.Size := 255;
    Rt_Credito_PresumidoDatasetapropria_via_nfe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetapropria_via_nfe.Name := 'Rt_Credito_PresumidoDatasetapropria_via_nfe';
    Rt_Credito_PresumidoDatasetapropria_via_nfe.FieldName := 'apropria_via_nfe';
    Rt_Credito_PresumidoDatasetapropria_via_evento.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetapropria_via_evento.Name := 'Rt_Credito_PresumidoDatasetapropria_via_evento';
    Rt_Credito_PresumidoDatasetapropria_via_evento.FieldName := 'apropria_via_evento';
    Rt_Credito_PresumidoDatasetind_deduz_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_deduz_credpres.Name := 'Rt_Credito_PresumidoDatasetind_deduz_credpres';
    Rt_Credito_PresumidoDatasetind_deduz_credpres.FieldName := 'ind_deduz_credpres';
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.Name := 'Rt_Credito_PresumidoDatasetind_gcbs_credpres';
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.FieldName := 'ind_gcbs_credpres';
    Rt_Credito_PresumidoDatasetind_gibs_credpres.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetind_gibs_credpres.Name := 'Rt_Credito_PresumidoDatasetind_gibs_credpres';
    Rt_Credito_PresumidoDatasetind_gibs_credpres.FieldName := 'ind_gibs_credpres';
    Rt_Credito_PresumidoDatasetexcluido.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetexcluido.Name := 'Rt_Credito_PresumidoDatasetexcluido';
    Rt_Credito_PresumidoDatasetexcluido.FieldName := 'excluido';
    Rt_Credito_PresumidoDatasetinclusao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetinclusao.Name := 'Rt_Credito_PresumidoDatasetinclusao';
    Rt_Credito_PresumidoDatasetinclusao.FieldName := 'inclusao';
    Rt_Credito_PresumidoDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Rt_Credito_PresumidoDatasetalteracao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetalteracao.Name := 'Rt_Credito_PresumidoDatasetalteracao';
    Rt_Credito_PresumidoDatasetalteracao.FieldName := 'alteracao';
    Rt_Credito_PresumidoDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Rt_Credito_PresumidoDatasetexclusao.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetexclusao.Name := 'Rt_Credito_PresumidoDatasetexclusao';
    Rt_Credito_PresumidoDatasetexclusao.FieldName := 'exclusao';
    Rt_Credito_PresumidoDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Rt_Credito_PresumidoDatasetindDecPag.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindDecPag.Name := 'Rt_Credito_PresumidoDatasetindDecPag';
    Rt_Credito_PresumidoDatasetindDecPag.FieldName := 'indDecPag';
    Rt_Credito_PresumidoDatasetindNFe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFe.Name := 'Rt_Credito_PresumidoDatasetindNFe';
    Rt_Credito_PresumidoDatasetindNFe.FieldName := 'indNFe';
    Rt_Credito_PresumidoDatasetindNFCe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFCe.Name := 'Rt_Credito_PresumidoDatasetindNFCe';
    Rt_Credito_PresumidoDatasetindNFCe.FieldName := 'indNFCe';
    Rt_Credito_PresumidoDatasetindNFSe.SetParentComponent(Rt_Credito_PresumidoDataset);
    Rt_Credito_PresumidoDatasetindNFSe.Name := 'Rt_Credito_PresumidoDatasetindNFSe';
    Rt_Credito_PresumidoDatasetindNFSe.FieldName := 'indNFSe';
    XDataClientRt_Credito_PresumidoGet.SetParentComponent(Self);
    XDataClientRt_Credito_PresumidoGet.Name := 'XDataClientRt_Credito_PresumidoGet';
    XDataClientRt_Credito_PresumidoGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRt_Credito_PresumidoGet, Self, 'OnLoad', 'XDataClientRt_Credito_PresumidoGetLoad');
    XDataClientRt_Credito_PresumidoGet.Left := 328;
    XDataClientRt_Credito_PresumidoGet.Top := 248;
  finally
    lbid.AfterLoadDFMValues;
    lbccredpres.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbapropria_via_nfe.AfterLoadDFMValues;
    lbapropria_via_evento.AfterLoadDFMValues;
    lbind_deduz_credpres.AfterLoadDFMValues;
    lbind_gcbs_credpres.AfterLoadDFMValues;
    lbind_gibs_credpres.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbindNFCe.AfterLoadDFMValues;
    lbindNFSe.AfterLoadDFMValues;
    lbindDecPag.AfterLoadDFMValues;
    lbindNFe.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edccredpres.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    cbApropria_via_nfe.AfterLoadDFMValues;
    cbApropria_via_evento.AfterLoadDFMValues;
    cbInd_deduz_credpres.AfterLoadDFMValues;
    cbInd_gcbs_credpres.AfterLoadDFMValues;
    cbInd_gibs_credpres.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    cbindNFCe.AfterLoadDFMValues;
    cbindNFSe.AfterLoadDFMValues;
    cbindDecPag.AfterLoadDFMValues;
    cbindNFe.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Rt_Credito_PresumidoDataset.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetid.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetccredpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetdescricao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetapropria_via_nfe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetapropria_via_evento.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_deduz_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_gcbs_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetind_gibs_credpres.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetexcluido.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetinclusao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetalteracao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetexclusao.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindDecPag.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFCe.AfterLoadDFMValues;
    Rt_Credito_PresumidoDatasetindNFSe.AfterLoadDFMValues;
    XDataClientRt_Credito_PresumidoGet.AfterLoadDFMValues;
  end;
end;

end.
